/** Badge text for an unread count — "99+" once the number reaches three digits. */
export function formatUnreadBadgeCount(count: number): string {
  if (count > 99) {
    return '99+';
  }
  return `${count}`;
}
